<template>
  <FormSection title="Profil">
    <template #text>
      Ändere die Profilinformationen Deines Accounts.
    </template>
    <template #form>
      <ProfileForm :resource="resource" :errors="errors" />
    </template>
  </FormSection>
  <FormButtons>
    <SubmitButton @click="onSubmit" :load="updating">
      Speichern
    </SubmitButton>
  </FormButtons>
</template>

<script setup>
import { ref, unref, computed } from 'vue';
import { useStore } from 'vuex';
import { useUpdateResource } from '@/client/actions';

const store = useStore();
const profile = unref({...store.getters['auth/user'].profile});

const username = {username: profile?.username};
const position = {position: profile?.position?.key};
const language = {language: profile?.language?.key};
const referrer = {referrer: profile?.referrer?.key};
const initial = {...username, ...position, ...language, ...referrer};

const resource = ref(initial);
const target = computed(() => '/api/account/profile');
const action = useUpdateResource(target, resource);

const { errors, message, updating, update } = action;

const onSuccess = () => store.dispatch('auth/reload');
const onSubmit = () => update(onSuccess);
</script>
